module.exports = __webpack_public_path__ + "static-portal/img/login-3.365e931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-3.png
// module id = Wczi
// module chunks = 4